import { baseClassName } from "./constants";
import classNames from "classnames";
import { ContentWrapper } from "./components/ContentWrapper/component";
import { NATIVE_AD_TYPE } from "../Ad/constants";
import {
    DATA_FEATURE_CARD_GRID,
    DATA_FEATURE_SWIMLANE,
} from "../../constants/tracking";
import styles from "./styles/themes/default.module.scss";
import useIsAuthorInfoHidden from "../../hooks/useIsAuthorInfoHidden";

//A function to get React keys for either Polopoly gridData or native ads.
export const getKeyforContent = (contentData, contentIndex) => {
    if (contentData.type === NATIVE_AD_TYPE) {
        return `key-${contentData.targeting.plc}-${contentData.targeting.sectionIndex}-${contentIndex}`;
    } else if (contentData.contentId) {
        return `key-${contentData.contentId}-${contentIndex}`;
    }

    //As a fallback for storybook stories
    return `key-${contentIndex}`;
};

/**
 * ContentGrid component.
 *
 * A configurable grid layout component.
 *
 * @param {Object} props The component props
 * @returns {React.Component} Returns the ContentGrid component
 */
export const ContentGrid = function (props) {
    const {
        gridLayout,
        gridData,
        path,
        featureInstance,
        className,
        cardClickHandler,
    } = props;
    const { defaultContent, positionalContent } = gridLayout;

    const contentLength = gridData.length;
    const isAuthorInfoHidden = useIsAuthorInfoHidden(path);

    const isList = gridLayout.isHtmlList(contentLength);

    const gridClasses = classNames(
        gridLayout.gridClasses,
        baseClassName,
        styles.contentGrid,
        className
    );

    const children = gridData.map((contentData, index) => {
        const contentLayout = positionalContent[index]
            ? positionalContent[index]
            : defaultContent;

        const props = {
            contentData,
            contentLayout,
            isList,
            path,
        };

        return (
            <ContentWrapper
                {...props}
                hideAuthorInfo={isAuthorInfoHidden}
                key={getKeyforContent(contentData, index)}
                contentIndex={index}
                cardClickHandler={cardClickHandler}
            />
        );
    });

    const getDataFeatureName = () => {
        if (children.length === 0) {
            return;
        }

        if (props.layoutName?.startsWith("featured") || children.length > 4) {
            return DATA_FEATURE_CARD_GRID;
        }

        return DATA_FEATURE_SWIMLANE;
    };

    if (isList) {
        return (
            <ul
                data-feature-name={getDataFeatureName()}
                data-feature-instance={featureInstance}
                className={gridClasses}
                data-testid="content-grid"
            >
                {children}
            </ul>
        );
    } else {
        return (
            <div
                data-feature-name={getDataFeatureName()}
                data-feature-instance={featureInstance}
                className={gridClasses}
                data-testid="content-grid"
            >
                {children}
            </div>
        );
    }
};

export default ContentGrid;
